import Beneficio from "./Beneficio";

export default Beneficio;
